import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { SessionStorageService } from '../../../../../../core/services/session-storage/session-storage.service';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { RegulatoryProfessionalQualifications } from '../regulatory-professional-qualifications-interface/regulatory-professional-qualifications.interface';


@Injectable({
  providedIn: 'root'
})
export class RegulatoryProfessionalQualificationsService {
  uploadFile(formData: FormData) {
    throw new Error('Method not implemented.');
  }
  setCertInGi(value: any) {
    throw new Error('Method not implemented.');
  }
  setHi(value: any) {
    throw new Error('Method not implemented.');
  }
  setCmCmp(value: any) {
    throw new Error('Method not implemented.');
  }
  setCommgi(value: any) {
    throw new Error('Method not implemented.');
  }
  setCmLip(value: any) {
    throw new Error('Method not implemented.');
  }
  setCmCis(value: any) {
    throw new Error('Method not implemented.');
  }
  setPgi(value: any) {
    throw new Error('Method not implemented.');
  }
  setM8Rep(value: any) {
    throw new Error('Method not implemented.');
  }
  setBcp(value: any) {
    throw new Error('Method not implemented.');
  }
  setM9(value: any) {
    throw new Error('Method not implemented.');
  }
  setM5Res5(value: any) {
    throw new Error('Method not implemented.');
  }

  private sessionStorageService = inject(SessionStorageService);
  http: any;

  constructor() { }
  
//get

  async getLicensing(request: any) {
    const API_URL: string = environment.baseUrl + environment.apis.getLicensingData;
   
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: request
    };

    return await axios.request(REQUEST_CONFIG)
      .then((response) => {
        return JSON.stringify(response);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }


//post

  async saveLicensingData(
    regulatoryProfessionalQualifications: RegulatoryProfessionalQualifications) {

    const API_URL: string =
      environment.baseUrl + environment.apis.saveLicensingData;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: regulatoryProfessionalQualifications.toString()
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

}


 




